module.exports = __webpack_public_path__ + "img/balance.b5f0399f.png";